import request from '@/utils/request'

// 查询生成表数据
export function listTable(query) {
  return request({
    url: '/admin/gen/list',
    method: 'get',
    params: query
  })
}
// 查询db数据库列表
export function listDbTable(query) {
  return request({
    url: '/admin/gen/db/list',
    method: 'get',
    params: query
  })
}

// 查询表详细信息
export function getGenTable(tableId) {
  return request({
    url: '/admin/gen/' + tableId,
    method: 'get'
  })
}

// 修改代码生成信息
export function updateGenTable(data) {
  return request({
    url: '/admin/gen',
    method: 'put',
    data: data
  })
}

// 导入表
export function importTable(data) {
  return request({
    url: '/admin/gen/importTable',
    method: 'post',
    data: data
  })
}

// 创建表
export function createTable(data) {
  return request({
    url: '/admin/gen/createTable',
    method: 'post',
    params: data
  })
}

// 预览生成代码
export function previewTable(tableId) {
  return request({
    url: '/admin/gen/preview/' + tableId,
    method: 'get'
  })
}

// 删除表数据
export function delTable(tableId) {
  return request({
    url: '/admin/gen/' + tableId,
    method: 'delete'
  })
}

// 生成代码（自定义路径）
export function genCode(tableName) {
  return request({
    url: '/admin/gen/genCode/' + tableName,
    method: 'get'
  })
}

// 同步数据库
export function synchDb(data) {
  return request({
    url: '/admin/gen/synchDb',
    method: 'post',
    data: data
  })
}

// 更新公共生成信息
export function updateCommon(data) {
  return request({
    url: '/admin/gen/common',
    method: 'put',
    data: data
  })
}
